import { styled } from '@material-ui/core';

export const Container = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  boxShadow: '0 1px 8px 0 rgba(0, 0, 0, 0.08)',
  borderRadius: '6px',
  width: '100%',
  height: '100%',
}));
